<template>
	<div class="md-layout">
		<entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" :entity.sync="entity"></entity-card>
	</div>
</template>

<script>
	import Category from "@/models/category.model.vue"
	// import Product from "@/models/product.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"

	export default {
		components: {
			EntityCard,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.id,
				},
				schema: Category.getSchema(),
			}
		},
		methods: {
			async createEntity(entity) {
				this.entity = await Category.create(entity);
				// await Product.reloadCategories();
				this.$router.replace(`/categoria/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				return Category.getInfo(entityId);
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return Category.updateInfo(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await Category.remove(entityId);
				this.$router.push("/categorias");
			},
		},
	};
</script>
